import React, { lazy } from "react";
import { useAuth } from "../../contexts/AuthContext";
import UnauthenticatedApp from "./UnauthenticatedApp";

const AuthenticatedApp = lazy(() => import("../../modules/common/AuthenticatedApp"));

const SureProtectedContents: React.FC = () => {
  const { loggedIn } = useAuth();

  return loggedIn ? <AuthenticatedApp /> : <UnauthenticatedApp />;
};

export default SureProtectedContents;
